import { NavLink } from 'react-router-dom';
import CoatOfArms from '../assets/img/LOGO.png';
import ArrowUp from '../assets/svg/ArrowUp.svg';
import { SITE_NAME } from '../config/siteConfig';
import { scrollToTop } from './motion/ScrollToTop';

// Footer labels follow Figma (1158:34548); routes match NAV_LINKS.
const FOOTER_LINKS = [
  { to: '',                    label: 'Overview' },
  { to: 'markets-prices',      label: 'Market Price' },
  { to: 'facilities-services', label: 'Facilities & Services' },
  { to: 'service-professionals', label: 'Service Professionals' },
  { to: 'contact-us',          label: 'Contact Us' },
];

export default function Footer() {
  return (
    <footer className="bg-[#f8f7f2]">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 px-4 py-10 sm:px-8 lg:flex-row lg:items-start lg:justify-between lg:px-10 pub-xl:px-[100px] lg:py-12">

        {/* Left: logo, name, year */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
          <NavLink to="" end className="flex items-center gap-2">
            <div className="h-[50px] w-[50px] shrink-0 shadow-[0_5px_5px_rgba(26,121,12,0.1)]">
              <img src={CoatOfArms} alt="" className="h-full w-full object-contain" />
            </div>
            <span className="max-w-[287px] text-[18px] leading-normal text-[#033219] sm:text-[20px]">
              {SITE_NAME}
            </span>
          </NavLink>
          <p className="text-[16px] text-[#0f3a26]">&copy;{new Date().getFullYear()}.</p>
        </div>

        {/* Right: links + back to top */}
        <div className="flex flex-col gap-8 sm:flex-row sm:items-end sm:gap-[124px]">
          <nav className="flex flex-col items-start gap-[10px]">
            {FOOTER_LINKS.map((link) => (
              <NavLink
                key={link.to || 'overview'}
                to={link.to}
                end={link.to === ''}
                className="whitespace-nowrap text-[18px] font-medium text-[#0f3a26] transition-colors hover:text-[#1fc16b] sm:text-[20px]"
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <button
            type="button"
            onClick={scrollToTop}
            className="flex items-center gap-1 text-[18px] font-medium text-[#0f3a26] transition-opacity hover:opacity-70"
          >
            Back to the top
            <img src={ArrowUp} alt="" width="24" height="24" className="h-6 w-6" />
          </button>
        </div>

      </div>
    </footer>
  );
}
